import { isMacOS } from '~/utils/devices'

// Format keyboard shortcuts for display (e.g. "meta+enter" → "⌘ + ↵")
export const formatShortcutKey = (key: string): string => {
  return key
    .split('+')
    .map((part) => {
      const normalizedPart = part.trim().toLowerCase()
      if (normalizedPart === 'meta') {
        return isMacOS() ? '⌘' : 'Ctrl'
      }
      if (normalizedPart === 'shift') return '⇧'
      if (normalizedPart === 'alt') return isMacOS() ? '⌥' : 'Alt'
      if (normalizedPart === 'ctrl' || normalizedPart === 'control')
        return 'Ctrl'
      if (normalizedPart === 'enter') return '↵'
      return part.trim().toUpperCase()
    })
    .join(' + ')
}
